module.exports = "<p>\r\n  payroll-filter works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/salaries/payroll-filter/payroll-filter.component.html
// module id = ./src/app/components/salaries/payroll-filter/payroll-filter.component.html
// module chunks = main